import abl from '../../abl';
import createTableData from './create_table_data';

const ScheduleTable = abl.createClass({
	initialize: function(props) {
		this.startTime = props.startTime;
		this.endTime = props.endTime;
		this.scheduledMeetings = props.scheduledMeetings;
		this.timeInterval = props.timeInterval;
		this.columnProperty = props.columnProperty;
		this.subColumnFilters = props.subColumnFilters;
		this.createUnscheduledMeeting = props.createUnscheduledMeeting;
		let tableData = {
			items: [],
			columns: { items: [], entities: {} },
			rowHeaders: [],
			cells: { items: [], entities: {} }
		};

		if(this.startTime && this.endTime) {
			tableData = createTableData(this);
		}
		
		this.items = tableData.items;
		this._columns = tableData.columns;
		this._rowHeaders = tableData.rowHeaders;
		this._rows = tableData.rows;
		this._cells = tableData.cells;
	},

	rowHeaders: function() {
		return this._rowHeaders;
	},

	columns: function() {
		return this._columns.items;
	},

	column: function(name) {
		return this._columns.entities[name];
	},

	cells: function() {
		return this._cells.items;
	},

	cell: function(id) {
		return this._cells.entities[id];
	}
});

export default ScheduleTable;


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/schedule_table.js
 **/